export {
  sequence,
  paginate,
  idOf,
  indexBy,
  transpose,
  indexArrayByKey,
  getSequences,
  sumByKey,
  toggleElement,
} from './collections';
export { executeLater, wait, debouncer, useDebounce, allPromisesSettled, loadAll, delay } from './async';
export {
  parseDate,
  getSimpleDate,
  getMonths,
  dateBetween,
  getCalculatedEventPublishedUntil,
  withinTimeRange,
  toFullDaysRange,
  atFullHour,
  addMsToDate,
  addSecondsToDate,
  addMinutesToDate,
  addHoursToDate,
  addDaysToDate,
  getDateRangeDuration,
} from './datetime';
export {
  formatCurrency,
  formatPercentage,
  formatDateTime,
  formatNumber,
  formatterLocale,
  formatDate,
  formatMonth,
  formatRelativeDate,
  formatTime,
  deleteSuffix,
  formatRangeOfDays,
  generateMailToLink,
  formatDateForDatabase,
  pluralize,
  formatDuration,
} from './formatters';
export {
  presence,
  present,
  coalesce,
  objectToParamsPart,
  joinJsonValues,
  objectToOptions,
  applyTax,
  removeTax,
  NaNGuard,
  getImageHash,
  oneLevelDiff,
  numerify,
  sortNumerically,
  compareNullity,
  comparePotentialNumbers,
  deepDiff,
  dig,
  isNumber,
  round,
} from './values';
export { smoothScrollToElement, nextAnimationFrame, downloadFiles } from './ui-helpers';
export { euroCountryCodes, mergePDF, parseBytes, readText, readBytes, readBytesUrl } from './data';
export { useReloadKey, useErrorHandler, wrapArray, useSelection, useAsyncIndicator } from './react-util';
export type { Selection } from './react-util';
export type { DownloadLink } from './ui-helpers';
export type { TimeFrame } from './datetime';

export type ExcludesUndefined = <T>(x: T | undefined) => x is T;

export type ExcludesFalse = <T>(x: T | false) => x is T;

export interface Violation {
  field: string;
  messages: string[];
}

export type Writeable<T> = { -readonly [P in keyof T]: T[P] };

export function exists<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function createHash(input: string): string {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash).toString(36);
}
